import { useTranslation } from 'next-i18next'
import Video from 'blocks/Video'

export function Accor() {
  const { t } = useTranslation('home.page')

  return (
    <Video
      title={t('accor.title')}
      youtubeId="c8-MDwE-w78"
      primaryLink={{
        title: t('accor.primary-link.title'),
        url: '/ressources/cas-client-accor',
        locale: false,
      }}
      secondaryLink={{
        title: t('accor.secondary-link.title'),
        url: '/loyalty',
        locale: false,
      }}
    />
  )
}
